export const CONTACT_DEPARTMENTS = [
  "Newsroom", "Customer Care", "Opinions Team", "Advertise",
  "Licensing & Syndication", "Request a Correction", "Send a News Tip",
];
